import React, { useState } from "react";
import { Button, Container, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import * as _ from "lodash";

import "react-datepicker/dist/react-datepicker.css";
import NibbleInput from "../../../components/Fields/NibbleInput";
import { PROFILES } from "../../../components/VerticalLayout/SidebarContent";
import { getStorageUser } from "../../../helpers/api_helper";
import { ORDER_BY, PERIOD, REPORT_TYPE } from "../static";

const capitalizeFirstLetter = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

const Filters = ({ validation, routes, branches }) => {
  const authUser = getStorageUser();

  return (
    <Row>
      <NibbleInput
        md={2}
        label="Tipo:"
        fieldName="report_type"
        fieldType="select"
        validation={validation}
        selectItems={_.values(REPORT_TYPE).map((item) => ({
          id: item,
          name: capitalizeFirstLetter(item),
        }))}
        selectIsSearchable={false}
        selectIsClearable={false}
      />
      {[PROFILES.SuperAdmin, PROFILES.Reseller].includes(
        authUser.profile_id
      ) && (
        <NibbleInput
          md={2}
          label="Ruta:"
          fieldName="route_id"
          fieldType="select"
          validation={validation}
          selectItems={routes}
        />
      )}
      <NibbleInput
        md={2}
        label="Ramal:"
        fieldName="branch_id"
        fieldType="select"
        validation={validation}
        selectItems={branches}
      />
      <NibbleInput
        md={2}
        label="Periodo:"
        fieldName="period"
        fieldType="select"
        validation={validation}
        selectItems={_.values(PERIOD).map((item) => ({
          id: item,
          name: item,
        }))}
        selectIsClearable={false}
      />
      <div className="mt-2 col-md-2">
        <label className="form-label">Rango del periodo:</label>
        <DatePicker
          selected={validation.values.period_range}
          onChange={(date) => {
            validation.setFieldValue("period_range", date);
          }}
          className="form-control"
          showWeekNumbers={validation.values.period == PERIOD.WEEK}
          showWeekPicker={validation.values.period == PERIOD.WEEK}
          showMonthYearPicker={validation.values.period == PERIOD.MONTH}
          dateFormat={
            validation.values.period == PERIOD.MONTH ? "MM-yyyy" : "dd-MM-yyyy"
          }
        />
      </div>
      <NibbleInput
        md={2}
        label="Ordenar por:"
        fieldName="order"
        fieldType="select"
        validation={validation}
        selectItems={_.values(ORDER_BY).map((item) => ({
          id: item,
          name: item,
        }))}
        selectIsSearchable={false}
        selectIsClearable={false}
      />
    </Row>
  );
};

export default Filters;
